<template>
  <div>
    <el-dialog :title="$t('message.badSummary')" :visible.sync="dialogVisible" width="98%" top="3vh"
      custom-class="bad-inspection-dialog" :close-on-click-modal="false" @closed="reset">
      <div class="bad-inspection">
        <div class="btn">
          <el-button type="primary" class="primary" @click="badConfirm" v-if="isAuth(210)">
            {{ $t('message.problemConfirmed') }}
          </el-button>
          <el-button type="primary" class="primary" @click="problemStore" v-if="isAuth(171)">
            {{ $t('message.askAQuestionAboutTheProduct') }}
          </el-button>
        </div>
        <div class="table">
          <ol>
            <li class="flex05">
              <el-checkbox v-model="checked" @change="allChed">{{ $t('message.allChecked') }}</el-checkbox>
            </li>
            <li class="flex2">{{ $t('message.orderNumber') }}</li>
            <li class="flex05">{{ $t('message.mash') }}</li>
            <li>{{ $t('message.pic') }}</li>
            <li class="flex15">{{ $t('message.theBusinessEditsTheCommodityProperties') }}</li>
            <li>{{ $t('message.numberOfProductsToBeInspected') }}</li>
            <li class="flex05">{{ $t('message.price') }}</li>
            <li class="flex2">待处理附加服务数量</li>
            <li class="flex15">{{ $t('message.transactionNumber') }}</li>
            <li class="flex15">{{ $t('message.logisticsNumber') }}</li>
            <li>{{ $t('message.numberOfGeneralTestprecisionTestProblems') }}</li>
            <li>{{ $t('message.numberOfLabelLayoutProblems') }}</li>
            <li>{{ $t('message.commodityNote') }}</li>
            <li>{{ $t('message.status') }}</li>
            <li>{{ $t('message.operation') }}</li>
          </ol>
          <div class="noData" v-if="tableData == false">暂无数据</div>
          <div class="itemDetail" v-for="(item, index) in tableData" :key="index">
            <div class="head">
              <div class="item checkbox">
                <el-checkbox v-model="item.checked" @change="checkedAll(index)"></el-checkbox>
              </div>
              <div class="item time">
                <p>{{ $t('message.forwardTime') }} : {{ item.submit_at }}</p>
              </div>
              <div class="item name">
                <span>{{ $t('message.inspector') }}：{{ item.j_admin != null ? item.j_admin.realname : '' }}</span>
              </div>
              <div class="item">
                <span>{{ $t('message.CheckList') }}：<a href="javascript:;">{{ item.inspect_sn }}</a></span>
              </div>
            </div>
            <ul v-for="(items, indexs) in item.list" :key="indexs" v-show="item.show">
              <li class="flex05">
                <label>
                  <el-checkbox v-model="items.checked" @change="changeItem(index)"></el-checkbox>
                </label>
              </li>
              <li class="flex2">
                <div>
                  <p>{{ items.order_detail.order_sn }}</p>
                  <p>{{ items.user != null ? items.user.realname : '' }}</p>
                </div>
              </li>
              <li class="flex05">{{ items.order_detail.sorting }}</li>
              <li>
                <div class="img">
                  <el-popover placement="right" width="300" trigger="hover">
                    <img :src="items.order_detail.pic" alt="" style="width: 300px; height: 300px" />
                    <a :href="`https://detail.1688.com/offer/${items.order_detail.goods_id}.html`" target="_blank"
                      slot="reference">
                      <img :src="items.order_detail.pic" alt="" />
                    </a>
                  </el-popover>
                </div>
              </li>
              <li class="flex15">
                <div class="template">
                  <p v-for="(skuItem, skuIndex) in items.order_detail.detail_y" :key="skuIndex">
                    <span>{{ skuItem.key }}:</span>
                    <span>{{ skuItem.value }}</span>
                  </p>
                </div>
              </li>
              <li>{{ items.num }}</li>
              <li class="flex05">{{ items.order_detail.confirm_price }}</li>
              <li class="flex2">
                <div class="template">
                  <el-tooltip placement="bottom" style="height: 100px; overflow: hidden">
                    <div slot="content">
                      <div class="row" v-for="(opti, optiIndex) in items.order_detail.option" :key="optiIndex"
                        style="margin-bottom: 3px">
                        <p>
                          {{ optiIndex + 1 }}.{{ opti.name }}:
                          <span v-if="opti.price_type != 1">{{ opti.num }} * {{ opti.price }}元</span>
                          <span v-else>{{ opti.price }}%</span>
                        </p>
                      </div>
                    </div>
                    <div style="height: 80px">
                      <div class="row" v-for="(opti, optiIndex) in items.order_detail.option" :key="optiIndex">
                        <p>
                          {{ optiIndex + 1 }}.{{ opti.name }}:
                          <span v-if="opti.price_type != 1">{{ opti.num }}*{{ opti.price }}元</span>
                          <span v-else>{{ opti.price }}%</span>
                        </p>
                      </div>
                    </div>
                  </el-tooltip>
                </div>
              </li>
              <li class="flex15">{{ items.purchase_no }}</li>
              <li class="flex15">
                <div class="template">
                  <p v-for="(wuliu, wuliuIndex) in items.order_purchase_express" :key="wuliuIndex">
                    WL{{ wuliuIndex + 1 }}:{{ wuliu.express_no }}
                  </p>
                </div>
              </li>
              <li>
                <div class="template">
                  <p>{{ $t('message.checkNumber') }}:{{ items.inspect_num }}</p>
                  <p>{{ $t('message.poorQuantity') }}:{{ items.inspect_num - items.num }}</p>
                  <p>{{ $t('message.adverseNumber') }}:{{ items.inspect_bad_num }}</p>
                </div>
              </li>
              <li>
                <div class="template">
                  <p>{{ $t('message.checkNumber') }}:{{ items.label_num }}</p>
                  <p>{{ $t('message.poorQuantity') }}:{{ item.label_admin != null ? items.label_num - items.num : 0 }}</p>
                  <p>{{ $t('message.adverseNumber') }}:{{ items.label_bad_num }}</p>
                </div>
              </li>
              <li>
                <el-button size="small" type="primary" class="primary" @click="lookRemark(items.order_detail)">
                  {{ $t('message.look') }}
                </el-button>
              </li>
              <li>
                <div>
                  <p>{{ items.status_name }}</p>
                  <el-tag size="mini" :type="items.is_print === 1 ? 'success' : 'info'">
                    {{ items.is_print === 1 ? $t('message.printed') : $t('message.notPrinted') }}
                  </el-tag>
                </div>
              </li>
              <li>
                <el-button size="small" type="primary" @click="printBadMark(item, items)">
                  {{ $t('message.print') }}
                </el-button>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <commodityNote v-if="commodityNoteDialogVisible" :commodityNoteData="commodityNoteData" />
      <badMarkLabel ref="badMarkLabel" />
    </el-dialog>
  </div>
</template>

<script>
import commodityNote from '@/components/common/commodityNote'
import badMarkLabel from '@/views/home/problemSolving/problem_bad/components/badMarkLabel.vue'

export default {
  name: 'BadInspection',
  components: { commodityNote, badMarkLabel },
  data() {
    return {
      dialogVisible: false,
      badMarkCode: '',
      inspectBadId: '',
      tableData: [],
      checked: false,
      commodityNoteData: {},
      commodityNoteDialogVisible: false,
    }
  },
  methods: {
    open(badMarkCode) {
      this.badMarkCode = badMarkCode
      this.inspectBadId = ''
      this.getData()
    },
    // 扫描 BL-不良ID 时复用不良核查弹窗。
    openById(inspectBadId) {
      this.badMarkCode = ''
      this.inspectBadId = inspectBadId
      this.getData()
    },
    getData() {
      const datas = {
        status: '0',
        page: 1,
        pageSize: 100,
      }
      if (this.inspectBadId) {
        datas.bad_id = this.inspectBadId
      } else {
        datas.bad_mark_code = this.badMarkCode
      }
      this.$api.inspectionApi.badList(datas).then((res) => {
        let tableData = []
        res.data.data.forEach((item) => {
          item.list = item.list.filter((items) => this.inspectBadId
            ? items.id == this.inspectBadId
            : items.bad_mark_code == this.badMarkCode)
          if (item.list.length > 0) {
            item.show = true
            item.checked = false
            item.list.forEach((items) => {
              items.checked = false
            })
            tableData.push(item)
          }
        })
        if (tableData.length === 0) {
          return this.$message.error(this.$t('message.badMarkCodeNotFound'))
        }
        this.tableData = tableData
        this.checked = false
        this.dialogVisible = true
      })
    },
    allChed() {
      this.tableData.forEach((item) => {
        item.checked = this.checked
        item.list.forEach((items) => {
          items.checked = this.checked
        })
      })
      this.$forceUpdate()
    },
    checkedAll(index) {
      this.tableData[index].list.forEach((items) => {
        items.checked = this.tableData[index].checked
      })
      this.$forceUpdate()
    },
    changeItem(index) {
      this.tableData[index].checked = this.tableData[index].list.every((items) => items.checked)
      this.checked = this.tableData.every((item) => item.checked)
    },
    getCheckedList() {
      let checkedList = []
      this.tableData.forEach((item) => {
        item.list.forEach((items) => {
          if (items.checked) checkedList.push(items)
        })
      })
      return checkedList
    },
    badConfirm() {
      const checkedList = this.getCheckedList()
      if (checkedList.length === 0) {
        return this.$message.error(this.$t('message.selectableOperationalList'))
      }
      const datas = {
        inspectBadIds: checkedList.map((item) => item.id),
      }
      this.$confirm(
        this.$t('message.isProblemConfirmed'),
        this.$t('message.prompt'),
        {
          confirmButtonText: this.$t('message.ok'),
          cancelButtonText: this.$t('message.cancel'),
          type: 'warning',
          center: true,
        }
      ).then(() => {
        this.$api.inspectionApi.badConfirm(datas).then((res) => {
          this.$message.success(res.msg)
          this.getData()
          this.$emit('confirmed')
        })
      }).catch(() => {})
    },
    problemStore() {
      const checkedList = this.getCheckedList()
      if (checkedList.length === 0) {
        return this.$message.error(this.$t('message.selectableOperationalList'))
      }
      const orderSn = Array.from(new Set(checkedList.map((item) => item.order_detail.order_sn)))
      if (orderSn.length > 1) {
        return this.$message.error(this.$t('message.danGeDanDingDan'))
      }
      const datas = {
        order_purchase_id: [],
        inspect_bad_list: [],
        type: 4,
      }
      checkedList.forEach((item) => {
        datas.order_purchase_id.push(item.order_purchase_id)
        datas.inspect_bad_list.push({
          inspect_bad_id: item.id,
          num: item.inspect_bad_num,
        })
      })
      this.$store.dispatch('getProblemList', datas)
    },
    lookRemark(item) {
      this.commodityNoteData = {
        p_remark: item.p_remark,
        y_remark: item.y_remark,
        g_remark: item.g_remark,
      }
      this.commodityNoteDialogVisible = true
    },
    printBadMark(item, items) {
      if (!items.bad_mark_code) return this.$message.error('暂无不良品编号')
      this.$refs.badMarkLabel.print({
        customer_attribute: items.attribute_name,
        user_name: items.user != null ? items.user.realname + '-' + items.user.id : '',
        bad_id: items.id,
        bad_mark_code: items.bad_mark_code,
        express_no: items.order_purchase_express != false ? items.order_purchase_express[0].express_no : '',
        bad_num: items.inspect_bad_num,
        checker_name: items.p_admin != null ? items.p_admin.realname : '',
        inspector_name: item.j_admin != null ? item.j_admin.realname : '',
        purchaser_name: items.g_admin != null ? items.g_admin.realname : '',
        salesman_name: items.y_admin != null ? items.y_admin.realname : '',
      })
      this.$api.inspectionApi.badMarkPrint({
        inspectBadIds: [items.id],
      }).then(() => {
        items.is_print = 1
      })
    },
    close() {
      this.dialogVisible = false
    },
    reset() {
      this.tableData = []
      this.checked = false
      this.commodityNoteDialogVisible = false
    },
  },
}
</script>

<style lang="scss" scoped>
/deep/ .bad-inspection-dialog {
  .el-dialog__body {
    padding: 10px 15px 30px;
    overflow-x: auto;
  }
}

.bad-inspection {
  min-width: 1500px;

  > .btn {
    margin-bottom: 20px;

    .el-button {
      margin-right: 20px;
    }
  }
}

.noData {
  padding: 20px 0;
  text-align: center;
}

.table {
  ol {
    display: flex;
    height: 40px;
    margin: 0;
    background-color: #edeff4;

    li {
      line-height: 20px;
    }
  }

  ul {
    display: flex;
    min-height: 120px;
    padding: 10px 0;
    border-bottom: 1px solid #e8e8e8;
    font-size: 12px;
    transition: 0.25s;

    &:hover {
      background-color: #eee;
      cursor: pointer;
    }

    li {
      width: 100%;
      word-break: break-all;

      .template {
        text-align: left;
      }
    }

    .img img {
      width: 60px;
      height: 60px;
      border-radius: 4px;
    }
  }

  li {
    display: flex;
    flex: 1;
    align-items: center;
    justify-content: center;
    padding: 0 3px;
    text-align: center;
  }

  .flex05 {
    position: relative;
    flex: 0.5;

    label {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 100%;
      height: 100%;
    }
  }

  .flex15 {
    flex: 1.3;
  }

  .flex2 {
    flex: 1.8;
  }

  .checkbox {
    margin-left: 15px;
  }

  .itemDetail .head {
    display: flex;
    height: 60px;
    background-color: #545467;
    color: #fff;
    font-size: 14px;

    a {
      color: #fff;
    }

    .item {
      margin-right: 48px;
      padding: 10px;
      line-height: 40px;

      span {
        margin-right: 30px;
      }
    }
  }
}
</style>
